var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
var index_exports = {};
__export(index_exports, {
  AsObjectFactory: () => AsObjectFactory,
  AsTypeFactory: () => AsTypeFactory,
  IsObjectFactory: () => IsObjectFactory,
  ObjectWrapper: () => ObjectWrapper,
  ValidatorBase: () => ValidatorBase,
  asAnyObject: () => asAnyObject,
  asJsonArray: () => asJsonArray,
  createDeepMerge: () => createDeepMerge,
  deepMerge: () => deepMerge,
  isJsonArray: () => isJsonArray,
  isJsonObject: () => isJsonObject,
  isJsonValue: () => isJsonValue,
  isObject: () => isObject4,
  isType: () => isType2,
  isValidJsonFieldPair: () => isValidJsonFieldPair,
  omitBy: () => omitBy,
  omitByPrefix: () => omitByPrefix,
  pickBy: () => pickBy,
  pickByPrefix: () => pickByPrefix,
  removeFields: () => removeFields,
  toJsonArray: () => toJsonArray,
  toJsonObject: () => toJsonObject,
  toJsonValue: () => toJsonValue,
  toSafeJson: () => toSafeJson,
  toSafeJsonArray: () => toSafeJsonArray,
  toSafeJsonObject: () => toSafeJsonObject,
  toSafeJsonString: () => toSafeJsonString,
  toSafeJsonValue: () => toSafeJsonValue,
  toValidJsonFieldPair: () => toValidJsonFieldPair
});

// src/index-deprecated.ts
var index_deprecated_exports = {};
__export(index_deprecated_exports, {
  AsObjectFactory: () => AsObjectFactory,
  AsTypeFactory: () => AsTypeFactory,
  IsObjectFactory: () => IsObjectFactory,
  ObjectWrapper: () => ObjectWrapper,
  ValidatorBase: () => ValidatorBase,
  asAnyObject: () => asAnyObject,
  asJsonArray: () => asJsonArray,
  createDeepMerge: () => createDeepMerge,
  deepMerge: () => deepMerge,
  isJsonArray: () => isJsonArray,
  isJsonObject: () => isJsonObject,
  isJsonValue: () => isJsonValue,
  isObject: () => isObject4,
  isType: () => isType2,
  isValidJsonFieldPair: () => isValidJsonFieldPair,
  omitBy: () => omitBy,
  omitByPrefix: () => omitByPrefix,
  pickBy: () => pickBy,
  pickByPrefix: () => pickByPrefix,
  removeFields: () => removeFields,
  toJsonArray: () => toJsonArray,
  toJsonObject: () => toJsonObject,
  toJsonValue: () => toJsonValue,
  toSafeJson: () => toSafeJson,
  toSafeJsonArray: () => toSafeJsonArray,
  toSafeJsonObject: () => toSafeJsonObject,
  toSafeJsonString: () => toSafeJsonString,
  toSafeJsonValue: () => toSafeJsonValue,
  toValidJsonFieldPair: () => toValidJsonFieldPair
});

// src/index-un-deprecated.ts
var index_un_deprecated_exports = {};
__export(index_un_deprecated_exports, {
  AsObjectFactory: () => AsObjectFactory,
  AsTypeFactory: () => AsTypeFactory,
  IsObjectFactory: () => IsObjectFactory,
  ObjectWrapper: () => ObjectWrapper,
  ValidatorBase: () => ValidatorBase,
  asAnyObject: () => asAnyObject,
  asJsonArray: () => asJsonArray,
  createDeepMerge: () => createDeepMerge,
  deepMerge: () => deepMerge,
  isJsonArray: () => isJsonArray,
  isJsonObject: () => isJsonObject,
  isJsonValue: () => isJsonValue,
  isObject: () => isObject4,
  isValidJsonFieldPair: () => isValidJsonFieldPair,
  omitBy: () => omitBy,
  omitByPrefix: () => omitByPrefix,
  pickBy: () => pickBy,
  pickByPrefix: () => pickByPrefix,
  removeFields: () => removeFields,
  toJsonArray: () => toJsonArray,
  toJsonObject: () => toJsonObject,
  toJsonValue: () => toJsonValue,
  toSafeJson: () => toSafeJson,
  toSafeJsonArray: () => toSafeJsonArray,
  toSafeJsonObject: () => toSafeJsonObject,
  toSafeJsonString: () => toSafeJsonString,
  toSafeJsonValue: () => toSafeJsonValue,
  toValidJsonFieldPair: () => toValidJsonFieldPair
});

// src/asObject.ts
import { isObject } from "@xylabs/typeof";

// src/AsTypeFactory.ts
import { assertDefinedEx } from "@xylabs/assert";
import { isPromise } from "@xylabs/promise";
import { isTruthy } from "@xylabs/typeof";
var AsTypeFactory = {
  create: (typeCheck) => {
    const func = (value, assertOrConfig, config) => {
      const isPredicate = typeof assertOrConfig === "number";
      const resolvedAssert = isPredicate ? void 0 : typeof assertOrConfig === "object" ? void 0 : assertOrConfig;
      const resolvedConfig = isPredicate ? void 0 : typeof assertOrConfig === "object" ? assertOrConfig : config;
      const required = isTruthy(resolvedConfig?.required);
      if (!required && (value === void 0 || value === null)) {
        return void 0;
      }
      if (isPromise(value)) {
        throw new TypeError('un-awaited promises may not be sent to "as" functions');
      }
      const result = typeCheck(value, resolvedConfig) ? value : void 0;
      if (resolvedAssert !== void 0) {
        return typeof resolvedAssert === "function" ? assertDefinedEx(result, resolvedAssert) : assertDefinedEx(result, () => resolvedAssert);
      }
      return result;
    };
    return func;
  },
  createOptional: (typeCheck) => {
    const func = (value) => {
      if (value === void 0 || value === null) return void 0;
      if (isPromise(value)) {
        throw new TypeError('un-awaited promises may not be sent to "as" functions');
      }
      return typeCheck(value) ? value : void 0;
    };
    return func;
  }
};

// src/AsObjectFactory.ts
var AsObjectFactory = {
  create: (typeCheck) => {
    return AsTypeFactory.create(typeCheck);
  },
  createOptional: (typeCheck) => {
    return AsTypeFactory.createOptional(typeCheck);
  }
};

// src/asObject.ts
var asAnyObject = (() => AsObjectFactory.create((obj) => isObject(obj)))();

// src/deepMerge.ts
var isUnsafeKey = (key) => key === "__proto__" || key === "constructor" || key === "prototype";
function merge(target, source, options) {
  if (!source || typeof source !== "object") return target;
  for (const key of Reflect.ownKeys(source)) {
    const value = source[key];
    if (isUnsafeKey(key)) {
      continue;
    } else if (Array.isArray(value)) {
      target[key] = options?.arrayStrategy === "concat" && Array.isArray(target[key]) ? [...target[key], ...value] : value;
    } else if (value !== null && typeof value === "object") {
      if (!target[key] || typeof target[key] !== "object") {
        target[key] = {};
      }
      merge(target[key], value, options);
    } else {
      target[key] = value;
    }
  }
  return target;
}
function createDeepMerge(options) {
  return function deepMerge2(...objects) {
    const result = options.mutate ? objects[0] ?? {} : {};
    for (const obj of objects) {
      merge(result, obj, options);
    }
    return result;
  };
}
var deepMerge = createDeepMerge({ arrayStrategy: "overwrite", mutate: false });

// src/IsObjectFactory.ts
import {
  isObject as isObject2,
  isTruthy as isTruthy2
} from "@xylabs/typeof";
import { isType } from "@xylabs/typeof";
var IsObjectFactory = class {
  create(shape, additionalChecks) {
    return (obj, config) => {
      if (!isObject2(obj)) {
        return false;
      }
      const log = typeof config === "object" ? config.log : void 0;
      return (
        // do primary check
        Object.entries(shape ?? {}).filter(([key, type]) => {
          const result = isType(obj[key], type);
          if (!result && isTruthy2(log)) {
            const logger = typeof log === "object" ? log : console;
            logger.warn(`isType Failed: ${key}: ${type}`);
          }
          return !result;
        }).length === 0 && (additionalChecks?.reduce((prev, check) => prev && check(obj, { log }), true) ?? true)
      );
    };
  }
};

// src/JsonObject.ts
import { isObject as isObject3, isString } from "@xylabs/typeof";
var isJsonValue = (value) => {
  switch (typeof value) {
    case "string":
    case "number":
    case "boolean": {
      return true;
    }
    default: {
      return value === null || isJsonObject(value) || isJsonArray(value);
    }
  }
};
var isJsonArray = (value) => {
  return Array.isArray(value) && !value.some((item) => !isJsonValue(item));
};
var asJsonArray = (value) => {
  if (Array.isArray(value)) {
    return value.filter(isJsonValue);
  } else {
    throw new TypeError(`Expected an array, got ${typeof value}`);
  }
};
var isValidJsonFieldPair = (value) => {
  if (!Array.isArray(value) || value.length !== 2) {
    return false;
  }
  const [key, val] = value;
  return isString(key) && isJsonValue(val);
};
var isJsonObject = (value) => {
  return isObject3(value) && !Object.entries(value).some((item) => !isValidJsonFieldPair(item));
};
var toJsonObject = (value) => {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    throw new TypeError(`Expected an object, got ${typeof value}`);
  }
  if (isJsonObject(value)) {
    return value;
  }
  const result = {};
  for (const [k, v] of Object.entries(value)) {
    if (v !== void 0) {
      const [key, jsonValue] = toValidJsonFieldPair([k, v]);
      result[key] = jsonValue;
    }
  }
  return result;
};
var toJsonValue = (value) => {
  if (isObject3(value)) {
    return toJsonObject(value);
  } else if (Array.isArray(value)) {
    return toJsonArray(value);
  } else if (isJsonValue(value)) {
    return value;
  }
  throw new TypeError(`Unable to coerce ${typeof value} to a JSON value`);
};
var toJsonArray = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => toJsonValue(item));
  }
  throw new TypeError(`Unable to coerce ${typeof value} to a JSON array`);
};
var toValidJsonFieldPair = (pair) => {
  const [key, value] = pair;
  if (!isString(key)) {
    throw new TypeError(`Expected a string key, got ${typeof key}`);
  }
  if (isJsonValue(value)) {
    return [key, value];
  } else if (isObject3(value)) {
    return [key, toJsonObject(value)];
  }
  throw new TypeError(`Expected a valid JSON value, got ${typeof value}`);
};

// src/ObjectWrapper.ts
var ObjectWrapper = class {
  obj;
  constructor(obj) {
    this.obj = obj;
  }
  get stringKeyObj() {
    return this.obj;
  }
};

// src/omitBy.ts
import { assertEx } from "@xylabs/assert";
var omitByArray = (obj, predicate, maxDepth) => {
  return obj.map((value) => {
    return value !== null && typeof value === "object" ? omitBy(value, predicate, maxDepth) : value;
  });
};
var omitByObject = (obj, predicate, maxDepth) => {
  const result = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const value = obj[key];
      if (!predicate(value, key)) {
        result[key] = value !== null && typeof value === "object" ? omitBy(value, predicate, maxDepth - 1) : value;
      }
    }
  }
  return result;
};
var omitBy = (obj, predicate, maxDepth = 1) => {
  if (maxDepth <= 0) {
    return obj;
  }
  return Array.isArray(obj) ? omitByArray(obj, predicate, maxDepth - 1) : omitByObject(obj, predicate, maxDepth - 1);
};
var omitByPrefixPredicate = (prefix) => (_, key) => {
  assertEx(typeof key === "string", () => `Invalid key type [${key}, ${typeof key}]`);
  return key.startsWith(prefix);
};
var omitByPrefix = (payload, prefix, maxDepth = 100) => {
  return omitBy(payload, omitByPrefixPredicate(prefix), maxDepth);
};

// src/pickBy.ts
import { assertEx as assertEx2 } from "@xylabs/assert";
var pickByArray = (obj, predicate, maxDepth) => {
  return obj.map((value) => {
    return value !== null && typeof value === "object" ? pickBy(value, predicate, maxDepth) : value;
  });
};
var pickByObject = (obj, predicate, maxDepth) => {
  const result = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const value = obj[key];
      if (predicate(value, key)) {
        result[key] = value !== null && typeof value === "object" ? pickBy(value, predicate, maxDepth - 1) : value;
      }
    }
  }
  return result;
};
var pickBy = (obj, predicate, maxDepth = 1) => {
  if (maxDepth <= 0) {
    return obj;
  }
  return Array.isArray(obj) ? pickByArray(obj, predicate, maxDepth - 1) : pickByObject(obj, predicate, maxDepth - 1);
};
var pickByPrefixPredicate = (prefix) => (_, key) => {
  assertEx2(typeof key === "string", () => `Invalid key type [${key}, ${typeof key}]`);
  return key.startsWith(prefix);
};
var pickByPrefix = (payload, prefix, maxDepth = 100) => {
  return pickBy(payload, pickByPrefixPredicate(prefix), maxDepth);
};

// src/removeFields.ts
var removeFields = (obj, fields) => {
  const clone = { ...obj };
  for (const field of fields) {
    delete clone[field];
  }
  return clone;
};

// src/toSafeJson.ts
var toSafeJsonArray = (value, cycleList, maxDepth = 3) => {
  return value.map((item) => toSafeJsonValue(item, cycleList, maxDepth));
};
var toSafeJsonObject = (value, cycleList, maxDepth = 3) => {
  const result = {};
  for (const [key, entry] of Object.entries(value)) {
    result[key] = value === void 0 ? "[Undefined]" : toSafeJsonValue(entry, cycleList, maxDepth);
  }
  return result;
};
var toSafeJsonValue = (value, cycleList, maxDepth = 3) => {
  if (maxDepth <= 0 && typeof value === "object") {
    return "[MaxDepth]";
  }
  if (cycleList?.includes(value)) {
    return "[Circular]";
  }
  switch (typeof value) {
    case "string":
    case "boolean":
    case "number": {
      return value;
    }
    case "object": {
      if (value === null) {
        return null;
      }
      const newCycleList = cycleList ?? [];
      newCycleList.push(value);
      return Array.isArray(value) ? toSafeJsonArray(value, newCycleList, maxDepth - 1) : toSafeJsonObject(value, newCycleList, maxDepth - 1);
    }
    default: {
      return `[${typeof value}]`;
    }
  }
};
var toSafeJsonString = (value, maxDepth = 3) => {
  return JSON.stringify(toSafeJson(value, maxDepth), null, 2);
};
var toSafeJson = (value, maxDepth = 3) => {
  return toSafeJsonValue(value, void 0, maxDepth);
};

// src/Validator.ts
var ValidatorBase = class extends ObjectWrapper {
};

// src/index-un-deprecated.ts
__reExport(index_un_deprecated_exports, object_model_star);
import * as object_model_star from "@xylabs/object-model";
import { isObject as isObject4 } from "@xylabs/typeof";

// src/index-deprecated.ts
__reExport(index_deprecated_exports, index_un_deprecated_exports);

// src/isType.ts
var isType2 = (value, expectedType) => {
  const typeofValue = typeof value;
  switch (expectedType) {
    case "array": {
      return Array.isArray(value);
    }
    case "null": {
      return value === null;
    }
    case "undefined": {
      return value === void 0;
    }
    case "object": {
      if (value === null) {
        return false;
      }
      return typeofValue === "object" && !Array.isArray(value);
    }
    default: {
      return typeofValue === expectedType;
    }
  }
};

// src/index.ts
__reExport(index_exports, index_deprecated_exports);
__reExport(index_exports, index_un_deprecated_exports);
export {
  AsObjectFactory,
  AsTypeFactory,
  IsObjectFactory,
  ObjectWrapper,
  ValidatorBase,
  asAnyObject,
  asJsonArray,
  createDeepMerge,
  deepMerge,
  isJsonArray,
  isJsonObject,
  isJsonValue,
  isObject4 as isObject,
  isType2 as isType,
  isValidJsonFieldPair,
  omitBy,
  omitByPrefix,
  pickBy,
  pickByPrefix,
  removeFields,
  toJsonArray,
  toJsonObject,
  toJsonValue,
  toSafeJson,
  toSafeJsonArray,
  toSafeJsonObject,
  toSafeJsonString,
  toSafeJsonValue,
  toValidJsonFieldPair
};
//# sourceMappingURL=index.mjs.map